export default class Career {
    constructor(options) {
        Object.assign(this, options)
    }

    toSend() {
        return {
            id: this.id,
            code: this.code,
            name: this.name,
            universityId: this.university.id,
            knowledgeAreaId: this.knowledgeArea.id,
        }
    }
}